var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      staticClass:
        "d-flex flex-row align-items-center justify-content-center my-2 small",
    },
    [
      _vm.includeRights
        ? _c("span", { staticClass: "mb-0" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("global.doorr.allRightsReserved")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.includeRights
        ? _c("span", { staticClass: "mx-2" }, [_vm._v("·")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "text-primary text-center",
          attrs: { href: _vm.PRIVACY_EXTERNAL_LINK, target: "_blank" },
        },
        [_vm._v(_vm._s(_vm.$t("global.doorr.privacyPolicy")))]
      ),
      _vm._v(" "),
      !_vm.clientLogin
        ? _c("span", { staticClass: "mx-2" }, [_vm._v("·")])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientLogin
        ? _c("span", { staticClass: "mx-2" }, [_vm._v("/")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "text-primary text-center",
          attrs: { href: _vm.TOS_EXTERNAL_LINK, target: "_blank" },
        },
        [_vm._v(_vm._s(_vm.$t("global.doorr.tos")))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }